import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp, faArrowDown, faFileExport } from '@fortawesome/free-solid-svg-icons'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import axios from 'axios'
import { apiUrl } from '../consts/consts'
import FileDownload from 'react-file-download'

function Results({ resultStatus, setResultStatus, resultData, hideZeroImpressions }) {
  const [sortOrder, setSortOrder] = useState('asc')
  const [sortBy, setSortBy] = useState(null)

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')
    } else {
      setSortBy(column)
      setSortOrder('asc')
    }
  }

  const sortedResultData = Array.isArray(resultData)
    ? resultData.slice().sort((a, b) => {
        if (sortBy === 'ad_requests') {
          return sortOrder === 'asc' ? a[sortBy] - b[sortBy] : b[sortBy] - a[sortBy]
        } else {
          return sortOrder === 'asc' ? a[sortBy]?.localeCompare(b[sortBy]) : b[sortBy]?.localeCompare(a[sortBy])
        }
      })
    : []

  async function handleExport() {
    const token = localStorage.getItem('Impact')

    const params = {
      r: resultData,
      o: '',
    }
    const date = new Date()
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear()
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    try {
      await axios
        .post(`${apiUrl}/getexcel`, params, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob',
        })
        .then((response) => {
          FileDownload(response.data, `${day}-${month}-${year}_${hours}.${minutes}_Impact_Marketplace.xlsx`)
        })
      toast.info('Impact_Marketplace.xlsx has been downloaded!', {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: 'toast-message',
      })
    } catch (error) {
      console.log(error)
    }
  }

  function handleClick() {
    setResultStatus((prevResultStatus) => !prevResultStatus)
  }
  return resultStatus ? (
    <div className="results-container">
      {resultData[0] ? (
        <div className="results-table">
          <table>
            <thead>
              <tr>
                <th onClick={() => handleSort('publisher_name')}>Publisher</th>
                <th onClick={() => handleSort('publisher_country')}>Country</th>
                <th onClick={() => handleSort('categories')}>Categories</th>
                <th onClick={() => handleSort('placement_group_url')}>Url</th>
                <th onClick={() => handleSort('formats')}>Formats</th>
                <th onClick={() => handleSort('supply_type')}>Inventory Type</th>
                <th onClick={() => handleSort('ad_requests')}>Ad Requests</th>
              </tr>
            </thead>
            {sortedResultData.map((result) => {
              if (hideZeroImpressions && result.ad_requests === 0) {
                return null
              }
              return (
                <tbody>
                  <tr>
                    <td>{result.publisher_name}</td>
                    <td>{result.publisher_country}</td>
                    <td>{result.categories}</td>
                    <td>{result.placement_group_url}</td>
                    <td>{result.formats}</td>
                    <td>{result.supply_type}</td>
                    {result.ad_requests === 'Low' ? (
                      <td
                        style={{
                          backgroundColor: 'lightgrey',
                        }}>
                        {result.ad_requests}
                      </td>
                    ) : result.ad_requests === 'Medium' ? (
                      <td style={{ backgroundColor: 'lightblue' }}>{result.ad_requests}</td>
                    ) : result.ad_requests === 'High' ? (
                      <td
                        style={{
                          backgroundColor: 'lightgreen',
                        }}>
                        {result.ad_requests}
                      </td>
                    ) : (
                      <td
                        style={{
                          backgroundColor: 'none',
                        }}>
                        {result.ad_requests}
                      </td>
                    )}
                  </tr>
                </tbody>
              )
            })}
          </table>
        </div>
      ) : (
        <div
          style={{
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            height: '100vh',
            width: '100vw',
            fontSize: '16px',
            flexDirection: 'column',
            lineHeight: '0',
          }}>
          <h3>No results found.</h3>
          <h4 style={{ fontWeight: '400', fontStyle: 'italic' }}>Try updating your filter(s) and press 'Search'</h4>
        </div>
      )}
      <div className="results-header">
        <h1>Results</h1>
        <div className="export-results">
          <button className="export-results" onClick={handleExport}>
            <FontAwesomeIcon className="export-icon" icon={faFileExport} />
          </button>
        </div>
      </div>
      <ToastContainer />
      <button className="close-results" onClick={handleClick}>
        <FontAwesomeIcon icon={faArrowDown} />
      </button>
    </div>
  ) : (
    <button className="open-results" onClick={handleClick}>
      <FontAwesomeIcon icon={faArrowUp} />
    </button>
  )
}

export default Results
